import { render } from "./BadgeItem.vue?vue&type=template&id=6a50a282&scoped=true"
import script from "./BadgeItem.vue?vue&type=script&lang=js"
export * from "./BadgeItem.vue?vue&type=script&lang=js"

import "./BadgeItem.vue?vue&type=style&index=0&id=6a50a282&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6a50a282"

export default script